<template>

<div class="main list-view">

	<div class="sub-header">
		<div class="input-with-control">
			<input type="text" ref="search_term" v-model="filters.search_term" placeholder="Search..." @keyup.enter="getList(1)" v-focus>
			<div class="button action input-go" @click="getList(1)"><i class="fas fa-search"></i></div>
		</div>
		<div class="controls">
			<pagination :paging="paging" @updatePage="goToPage"></pagination>
		</div>
	</div>

	<div class="filters" v-if="showFilters">
		<div class="label-group">
			<label>Start</label>
			<input type="date" v-model="filters.start_date" :max="$today().clone().format('YYYY-MM-DD')">
		</div>
		<div class="label-group">
			<label>End</label>
			<input type="date" v-model="filters.end_date" :max="$today().clone().format('YYYY-MM-DD')">
		</div>
		<div class="label-group">
			<label></label>
			<div class="button small neutral" @click="getList(1)">Filter Dates</div>
		</div>
		<div class="label-group">
			<label></label>
			<ul class="checkbox-group">
				<li>
					<span :class="['pointer', 'far', filters.payment_date ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('payment_date')"></span>
					<label>Payment Date</label>
				</li>
				<li>
					<span :class="['pointer', 'far', filters.order_date ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('order_date')"></span>
					<label>Original Order Date</label>
				</li>
			</ul>
		</div>
		<div class="divider"></div>
		<div v-if="!showDetail" :class="['extra-menu-item', { 'disabled': gettingExport }]" @click="doExport()">Export CSV</div>
		<div class="message">{{ exportMessage }}</div>

		<button v-if="showDetail" class="button neutral" @click="backToList()">Back To List</button>

	</div>

	<div v-if="!showDetail" class="list">

	    <div v-if="list.length == 0" class="empty-list">
	        This list is empty
	    </div>

	    <table v-else class="data-list" cellpadding="0" cellspacing="0">
			<thead>
				<tr>
					<th class="list">Date</th>
					<th class="list">Customer</th>
					<th class="list">Type</th>
					<th class="list">Reference #</th>
					<th class="list right">Amount</th>
					<th class="list" style="padding: 0 1em;"></th>
					<th class="list">Order Date</th>
					<th class="list">Order #</th>
					<th class="list">Status</th>
					<th class="list right">Total</th>
					<th class="list right">Balance</th>
				</tr>
			</thead>
			<tr v-for="(payment, index) in list" class="clickable-list-item" @click="getItem(payment.order_id)">
				<td class="list">{{ payment.payment_date }}</td>
				<td class="list">{{ payment.full_name }}</td>
				<td class="list">{{ payment.type }}</td>
				<td class="list">{{ payment.reference_number }}</td>
				<td class="list right">{{ payment.amount }}</td>
				<td class="list"></td>
				<td class="list">{{ payment.order_date }}</td>
				<td class="list">{{ payment.order_number }}</td>
				<td class="list">{{ payment.order_status }}</td>
				<td class="list right">{{ payment.order_total }}</td>
				<td class="list right">{{ payment.balance_due }}</td>
			</tr>
		</table>

	</div>

	<div v-if="showDetail" class="detail">
		<order-detail :orderDetail="orderDetail" />
	</div>

	<message-modal v-if="message" :message="message" :loading="loading" :errorStatus="messageStatus" :timeout="messageTimeout" @dismiss="message = ''" />

	<iframe id="download" src="" style="display: none;"></iframe>

</div>

</template>

<script>
import OrderDetail from '@/components/OrderDetail.vue'
export default {
	name: 'report-list',
	props: ['order_id'],
    components: {
        'order-detail': OrderDetail
	},
	data() {
		return {
            loading: false,
			message: '',
			messageStatus: '',
			messageTimeout: 0,
			page: 1,
			showFilters: true,
			filters: {},
            default_start_date: '',
            default_end_date: '',
			filterMessage: '',
			filterLoading: false,
			definition: [],
			list: [],
			paging: {},
			showDetail: false,
			orderDetail: {},
			exportMessage: '',
			gettingExport: false,
			orderStatus: ''
		}
	},
	created() {
		this.clearFilters(true)
	},
	methods: {
		clearFilters(getList) {
			this.filters = {
				page: 1,
				search_term: '',
				start_date: '',
				payment_date: true,
				order_date: false,
				end_date: '',
				order_id: '',
				do_export: false
			}
			var oneMonthAgo = new Date()
			oneMonthAgo.setMonth(oneMonthAgo.getMonth() -1)
			this.default_start_date = oneMonthAgo.toISOString().slice(0,10)
			this.default_end_date = new Date().toISOString().slice(0,10)
			this.filters.start_date = this.default_start_date
			this.filters.end_date = this.default_end_date
			if (getList) {
				this.getList(1)
			}
		},
		toggleFilter(which) {
			this.filters.payment_date = !this.filters.payment_date
			this.filters.order_date = !this.filters.order_date
			this.filters.page = 1
			this.getList()
		},
		getList(page) {
			if (this.loading) { return }
			if (page) {
				this.filters.page = page
			}
			this.loading = true
			this.message = 'Loading layaway payments...'
			this.messageStatus = 'waiting'
			this.apiCall({ destination: 'get_list_layaway_payments', data: this.filters }).then(obj => {
				this.loading = false
				this.messageStatus = obj.status
				if (this.filters.do_export) {
					this.filters.do_export = 0
					document.getElementById("download").src = obj.download_url
					this.gettingExport = false
					this.exportMessage = ''
					this.message = ''
				} else {
					this.message = ''
					this.list = obj.list
					this.paging = obj.paging
				}
			}).catch(err => {
				console.log(err)
			})
		},
		goToPage(page) {
			this.filters.page = page
			this.getList()
		},
		getItem(orderId) {
			// TODO: deprecate legacy order link once new order program is complete
			//this.$router.push('/legacy/ordermaintenance.php?url_page=show&no_controls=1&primary_id=' + orderId)
			//return
			// TODO: use below when new order program is complete
			this.loading = true
			this.apiCall({ destination: 'get_item_order', data: { order_id: orderId } }).then(obj => {
				this.orderDetail.order = obj.order_detail
				this.orderDetail.billing = obj.order_billing_address
				this.orderDetail.shipping = obj.order_shipping_address
				this.orderDetail.items = obj.order_items
				this.orderDetail.discount = obj.order_discounts
				this.orderDetail.fees = obj.order_fees
				this.orderDetail.payments = obj.order_payments
				this.orderDetail.totals = obj.order_totals
				this.orderStatus = obj.order_detail.order_status_code
				this.loading = false
				this.showDetail = true
			}).catch(err => {
				console.log(err)
			})
		},
		updateStatus() {
			// update this order status with this.orderStatus
		},
		backToList() {
			this.showDetail = false
			this.orderDetail = {}
		},
		doExport() {
			if (this.gettingExport) {
				return false
			}
			this.gettingExport = true
			this.exportMessage = 'Generating CSV for ' + this.paging.total_items + ' items...'
			this.filters.order_id = ''
			this.filters.do_export = true
			this.getList(1)
		}
	}
}
</script>

<style lang="scss" scoped>
</style>
